import { useEffect } from "react";
import { HeroSection } from "@/components/HeroSection";
import { PainPoints } from "@/components/PainPoints";
import { TwoRoutes } from "@/components/TwoRoutes";
import { DiagnosticSection } from "@/components/DiagnosticSection";
import { ImproveSection } from "@/components/ImproveSection";
import { UseCasesSection } from "@/components/UseCasesSection";
import { ProcessSection } from "@/components/ProcessSection";
import { ServicesSection } from "@/components/ServicesSection";
import { CaseStudies } from "@/components/CaseStudies";
import { FounderSection } from "@/components/FounderSection";
import { CoachingSection } from "@/components/CoachingSection";
import { CTASection } from "@/components/CTASection";
import { siteMeta } from "@/data/mock";

export default function HomePage() {
  useEffect(() => {
    document.title = siteMeta.title;
  }, []);

  return (
    <>
      <HeroSection />
      <PainPoints />
      <TwoRoutes />
      <DiagnosticSection />
      <ImproveSection />
      <UseCasesSection />
      <ProcessSection />
      <ServicesSection />
      <CaseStudies />
      <FounderSection />
      <CoachingSection />
      <CTASection />
    </>
  );
}
